import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { toNumber, flowRight as compose } from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import publicImgBaseURL from 'commons/publicImgBaseURL';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import ReviewStars from 'components/consumer/ReviewStars';
import ReviewsSearch from '../ReviewSearch';
import { sortOptions as defaultSortOptions } from '../utils';
const CustomerReviewsHeader = t0 => {
  const $ = _c(29);
  const {
    averageScore,
    match,
    onSortChanged,
    product,
    refetch,
    searchState,
    sortOptions: t1,
    subTitle,
    title,
    totalReviewsCount,
    type
  } = t0;
  const sortOptions = t1 === undefined ? defaultSortOptions : t1;
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [selectedSortOption, setSelectedSortOption] = useState(sortOptions[0]);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSidebarOpen(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isSidebarOpen) {
    t3 = <LoginSidebar show={isSidebarOpen} onClose={t2} />;
    $[1] = isSidebarOpen;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== averageScore || $[4] !== onSortChanged || $[5] !== refetch || $[6] !== searchState || $[7] !== selectedSortOption || $[8] !== sortOptions || $[9] !== subTitle || $[10] !== title || $[11] !== totalReviewsCount || $[12] !== type) {
    t4 = type !== "allProducts" && type !== "productReviews" ? <div className="max-w-[1400px] mt-8 mx-[3.333vw] mb-4 min-[1440px]:mt-[6.25rem] min-[1440px]:mx-auto min-[1440px]:mb-4"><h1 className="text-2xl text-gray mt-0 mx-0 mb-2 font-bold text-center">{title}</h1><div className="text-lg text-gray mb-6 text-center">{subTitle}</div><div className="flex flex-col min-[1440px]:px-5 min-[1440px]:py-0 max-[767px]:flex-col max-[767px]:items-center max-[767px]:justify-center max-[568px]:flex-col max-[568px]:items-center max-[568px]:justify-center">{totalReviewsCount > 0 ? <div className="self-center mb-8"><div className="rating flex"><ReviewStars rating={averageScore} noSpacing={true} readOnly={true} size="sm" /><div className="text-sm pl-[.3rem]">{toNumber(averageScore).toFixed(1)} / 5</div><div className="text-sm pl-[.8rem]">({totalReviewsCount} Reviews)</div></div></div> : null}<div className="flex justify-between items-center max-[767px]:flex-col max-[767px]:items-center max-[767px]:justify-center"><div className="w-2/5 max-[767px]:w-3/5 max-[767px]:mb-4 max-[568px]:w-full">{searchState ? <ReviewsSearch inSearchMode={searchState.inSearchMode} onSearchUpdate={searchState.onSearchUpdate} onProductClicked={searchState.onProductClicked} onProduct={searchState.onProduct} /> : null}</div><div className={"flex justify-end items-center w-1/4  flex-row max-[767px]:w-3/5 max-[767px]:flex-col max-[767px]:justify-center max-[568px]:w-full [&_.Select-value-label]:before:[content:\"Sort_by:\"]"}><div className="w-full max-[767px]:mb-4 border border-solid border-transparent mt-px"><LabeledSelectBox label="Sort by" options={sortOptions} value={selectedSortOption.value} className="flex-1" onChange={e => {
                const selectedOption = sortOptions.find(option => option.value === e.target.value);
                setSelectedSortOption(selectedOption);
                onSortChanged(selectedOption, refetch);
              }} showBlankOption={false} showSingleLineLabelOverlay={true} /></div></div></div></div></div> : null;
    $[3] = averageScore;
    $[4] = onSortChanged;
    $[5] = refetch;
    $[6] = searchState;
    $[7] = selectedSortOption;
    $[8] = sortOptions;
    $[9] = subTitle;
    $[10] = title;
    $[11] = totalReviewsCount;
    $[12] = type;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== averageScore || $[15] !== match || $[16] !== onSortChanged || $[17] !== product || $[18] !== refetch || $[19] !== selectedSortOption || $[20] !== sortOptions || $[21] !== subTitle || $[22] !== totalReviewsCount || $[23] !== type) {
    t5 = type === "productReviews" && !!product ? <div className="max-w-[1400px] mt-8 mx-[3.333vw] mb-4 min-[1440px]:mt-[6.25rem] min-[1440px]:mx-auto min-[1440px]:mb-4"><div className="text-2xl text-gray mt-0 mx-0 mb-2 font-bold text-center">Customers love the {product.name}</div><div className="text-lg text-gray mb-6 text-center">{subTitle}</div><div className="flex flex-col min-[1440px]:px-5 min-[1440px]:py-0 max-[767px]:flex-col max-[767px]:items-center max-[767px]:justify-center max-[568px]:flex-col max-[568px]:items-center max-[568px]:justify-center"><div className="flex w-full flex-row justify-between max-[767px]:flex-col max-[767px]:items-center max-[767px]:justify-center max-[568px]:flex-col max-[568px]:items-center max-[568px]:justify-center"><div className="w-1/2 flex justify-start max-[767px]:w-3/5 max-[767px]:mb-4 max-[568px]:w-full max-[568px]:flex max-[568px]:flex-col max-[568px]:text-center"><div>{product.images && product.images.length && <div className="max-[568px]:w-full flex max-[765px]:w-full mr-4 w-40 items-center justify-center mb-4"><JBImage src={publicImgBaseURL(product.images[0].url)} alt="" loader={true} trim="color" trimPad={20} height={140} className="[&_img]:object-contain" /></div>}</div><div className="self-center mb-8">{product.name}<div className="rating flex"><ReviewStars rating={averageScore} noSpacing={true} readOnly={true} size="sm" /><div className="text-sm pl-[.3rem]">{toNumber(totalReviewsCount)} Reviews</div></div><Link className="text-base font-bold text-brand" to={`/${match.params.category}/${match.params.slug}`}>Shop</Link></div></div><div className="w-1/4 mt-8 flex flex-row justify-end max-[767px]:w-3/5 max-[767px]:flex-col max-[767px]:justify-center max-[568px]:w-full"><div className="w-full max-[767px]:mb-4 border border-solid border-transparent mt-px"><LabeledSelectBox label="Sort by" options={sortOptions} value={selectedSortOption.value} className="flex-1" onChange={e_0 => {
                const selectedOption_0 = sortOptions.find(option_0 => option_0.value === e_0.target.value);
                setSelectedSortOption(selectedOption_0);
                onSortChanged(selectedOption_0, refetch);
              }} showBlankOption={false} showSingleLineLabelOverlay={true} /></div></div></div></div></div> : null;
    $[14] = averageScore;
    $[15] = match;
    $[16] = onSortChanged;
    $[17] = product;
    $[18] = refetch;
    $[19] = selectedSortOption;
    $[20] = sortOptions;
    $[21] = subTitle;
    $[22] = totalReviewsCount;
    $[23] = type;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  return t6;
};
CustomerReviewsHeader.propTypes = {
  averageScore: PropTypes.number,
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string,
      slug: PropTypes.string
    })
  }),
  onProduct: PropTypes.func,
  onProductClicked: PropTypes.func,
  onSearchUpdate: PropTypes.func,
  onSortChanged: PropTypes.func,
  product: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string
    }))
  }),
  refetch: PropTypes.func,
  searchState: PropTypes.shape({
    inSearchMode: PropTypes.bool,
    onProduct: PropTypes.number,
    onProductClicked: PropTypes.func,
    onSearchUpdate: PropTypes.func
  }),
  selectedSortOption: PropTypes.shape({
    value: PropTypes.string
  }),
  sortOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  subTitle: PropTypes.string,
  title: PropTypes.string,
  totalReviewsCount: PropTypes.number,
  type: PropTypes.string
};
export default compose(withRouter)(CustomerReviewsHeader);